import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/client/age-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedButtons","AnimatedScrollButton"] */ "/vercel/path0/components/client/animated-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedSection","AnimatedDiv","AnimatedH1","AnimatedP","AnimatedH2"] */ "/vercel/path0/components/client/animated-sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/client/hero-interactive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/client/hero-typing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/client/page-transition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","TerminalOutput"] */ "/vercel/path0/components/client/terminal-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/client/work-experience-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/form/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
